import { __awaiter as t, __generator as e, __values as n, __spread as o } from "tslib";
import { logger as r } from "@liff/logger";

var i = function i(t, e) {
  var n = this;
  this._driver = t, this.liff = e, this.addHooks = function (t) {
    n._driver.addHooks(t);
  };
},
    a = function () {
  function r() {
    this.modules = new Set(), this.hooksSet = new Set();
  }

  return r.prototype.addHooks = function (t) {
    this.hooksSet.add(t);
  }, r.prototype.addModule = function (t) {
    this.modules.add(t);
  }, r.prototype.hasModule = function (t) {
    return this.modules.has(t);
  }, r.prototype.runHook = function (r) {
    for (var i = [], a = 1; a < arguments.length; a++) {
      i[a - 1] = arguments[a];
    }

    return t(this, void 0, void 0, function () {
      var t, a, u, s, l, f, h, c;
      return e(this, function (e) {
        switch (e.label) {
          case 0:
            t = [];

            try {
              for (a = n(this.hooksSet), u = a.next(); !u.done; u = a.next()) {
                s = u.value, "function" == typeof (l = s[r]) && (f = l.apply(void 0, o(i)), t.push(f));
              }
            } catch (p) {
              h = {
                error: p
              };
            } finally {
              try {
                u && !u.done && (c = a.return) && c.call(a);
              } finally {
                if (h) throw h.error;
              }
            }

            return [4, Promise.all(t)];

          case 1:
            return e.sent(), [2];
        }
      });
    });
  }, r.prototype.runSyncHook = function (t) {
    for (var e, r, i = [], a = 1; a < arguments.length; a++) {
      i[a - 1] = arguments[a];
    }

    try {
      for (var u = n(this.hooksSet), s = u.next(); !s.done; s = u.next()) {
        var l = s.value,
            f = l[t];
        "function" == typeof f && f.apply(void 0, o(i));
      }
    } catch (h) {
      e = {
        error: h
      };
    } finally {
      try {
        s && !s.done && (r = u.return) && r.call(u);
      } finally {
        if (e) throw e.error;
      }
    }
  }, r;
}(),
    u = function () {
  function t(t, e, n) {
    this.driver = t, this.context = e, this.option = n;
  }

  return t.prototype.install = function () {
    return this.factory(this.driver, this.context);
  }, Object.defineProperty(t.prototype, "name", {
    get: function get() {
      return "use";
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "defaultOption", {
    get: function get() {
      return {
        namespacePrefix: "$"
      };
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.factory = function (t, e) {
    var n = Object.assign({}, this.defaultOption, this.option).namespacePrefix;
    return function (o, i) {
      if (t.hasModule(o)) return this;
      if (!o || "function" != typeof o.install || "string" != typeof o.name) return r.warn("To install the plugin, you need to define the `name` property and the `install` method."), this;
      var a = "" + n + o.name,
          u = o.install.call(o, e, i);
      return this["" + a] ? (r.warn("There is a duplicate plugin name. `" + o.name + "` plugin namespace will be override."), this["" + a] = u) : void 0 !== u && (this["" + a] = u), t.addModule(o), this;
    };
  }, t;
}();

export { i as ModuleContextImpl, a as ModuleDriverImpl, u as UseModule };